import { JoinFreeClassData } from "@/src/lib/types/home";
import ClientJoinFreeClass from "./JoinFreeClass/Client";


interface Props {
  data: JoinFreeClassData;
}

export default function JoinFreeClass({ data }: Props) {
  return <ClientJoinFreeClass data={data} />;
}
